import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {DateAdapter, ErrorStateMatcher, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-site-event-dialog',
  templateUrl: './site-event-dialog.component.html',
  styleUrls: [ './site-event-dialog.component.scss' ]
})

export class SiteEventDialogComponent implements OnInit, OnDestroy {

  public Editor = ClassicEditor

  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean = false;

  // Variáveis para upload
  selectedFile: File | null = null;
  selectedFileName: any | null = null;
  storedImage: any | null = null;

  public image_path: string;

  public types: any = []

  constructor (
    public matDialogRef: MatDialogRef<SiteEventDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log("dialog data: " + JSON.stringify(this.data));
    this.entityForm = this.createForm(this.data)
    this.isEdit = this.data.id !== '0';

    this.types.push({id: 'Nacional', name: 'Nacional'})
    this.types.push({id: 'Internacional', name: 'Internacional'})
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
  }

  ngOnDestroy () { }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      type: new FormControl(data.type, [ Validators.required ]),
      name: new FormControl(data.name, [ Validators.required ]),
      dateStart: new FormControl(data.dateStart?.toDate() || null, [ Validators.required ]),
      dateEnd: new FormControl(data.dateEnd?.toDate() || null, [ Validators.required ]),
      coordinator: new FormControl(data.coordinator),
      location: new FormControl(data.location),
      city: new FormControl(data.city),
      country: new FormControl(data.country),
      site: new FormControl(data.site),
      email: new FormControl(data.email),
      hour: new FormControl(data.hour),
      description: new FormControl(data.description),
      information: new FormControl(data.information),

      src: new FormControl(data.src),
      file: new FormControl(data.file, [ Validators.required ]),
      dateIn: new FormControl(data.dateIn?.toDate() || null, [ Validators.required ]),
      dateOut: new FormControl(data.dateOut?.toDate() || null, [ Validators.required ]),

    });

    this.selectedFileName = data.file;
    this.storedImage = data.src;

    return form
  }

  onFileSelected (event: any): void {
    const file: File = event.target.files[ 0 ];
    if (file) {
      this.selectedFile = file;
      this.entityForm.controls.file.setValue(file.name);
      this.previewImage(this.selectedFile)
    }
  }

  previewImage (selectedFile: any) {

    var reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
    }
  }



}

